<template>
  <div class="text-center">
    <v-dialog v-model="flag" width="800" scrollable>
      <v-card>
        <!-- Title bar -->
        <v-card-title
          class="py-3 px-4 text-truncate dialog-title-border dark-purple-text"
        >
          <div class="d-flex justify-center align-center" style="width: 90%">
            Advanced Filters
          </div>

          <v-spacer></v-spacer>
          <v-icon small color="#757096" @click="flag = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="custom-dialog">
          <!-- FILTER BY -->
          <div
            v-if="
              getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'owner'
            "
            :class="
              $vuetify.breakpoint.xs
                ? 'd-flex flex-column'
                : 'd-flex border-bottom'
            "
            style="min-height: 88px"
          >
            <!-- Filter Types -->

            <div
              :class="!$vuetify.breakpoint.xs ? 'w-45' : ''"
              class="my-2 mx-1"
            >
              <div
                class="dark-purple-text font-weight-bold text-capitalize body-2"
              >
                Filter by
              </div>
              <div class="d-flex align-end py-2">
                <v-chip
                  v-for="list of reportsList"
                  :key="list.text"
                  @click="$store.commit('setReportsView', list.value)"
                  small
                  class="mt-2 pointer mr-2"
                  :class="
                    getReportsView == list.value
                      ? 'blue-chip-color'
                      : 'grey-chip-color'
                  "
                >
                  {{ list.text }}
                </v-chip>
              </div>
            </div>
            <!-- DOTTED DIVIDER -->
            <div
              style="height: 50px"
              class="border-right mt-4 mr-4"
              v-show="
                getSelectedCompany.role != 'employee' &&
                  getReportsView != 'project' &&
                  !$vuetify.breakpoint.xs
              "
            ></div>
            <!-- Task Categories -->
            <div
              v-show="
                getSelectedCompany.role != 'employee' &&
                  getReportsView != 'project'
              "
              :class="!$vuetify.breakpoint.xs ? 'w-45' : ''"
              class="my-2"
            >
              <div
                class="dark-purple-text font-weight-bold text-capitalize body-2"
              >
                By Task Category
                <!-- <v-icon class="pointer" x-small>mdi-information-outline</v-icon> -->
              </div>
              <div class="d-flex my-2">
                <!-- Show All Tasks Filter -->
                <div
                  class="pointer pr-2 py-2 caption d-flex anchor-hover pointer"
                  @click="$store.commit('setReportsStatus', { status: 'all' })"
                >
                  <v-icon
                    small
                    color="#1cc283"
                    class="mr-3"
                    v-text="
                      getReportsStatus == 'all'
                        ? 'mdi-checkbox-marked-circle'
                        : 'mdi-checkbox-blank-circle-outline'
                    "
                  ></v-icon>
                  <span
                    :class="
                      getReportsStatus == 'all'
                        ? 'success-text font-weight-bold'
                        : ''
                    "
                  >
                    All Tasks
                  </span>
                  <v-spacer></v-spacer>
                </div>
                <!-- Show Only Me Tasks Filter -->
                <div
                  class="pa-2 caption d-flex anchor-hover pointer"
                  @click="$store.commit('setReportsStatus', { status: 'self' })"
                >
                  <v-icon
                    small
                    color="#1cc283"
                    class="mr-3"
                    v-text="
                      getReportsStatus == 'self'
                        ? 'mdi-checkbox-marked-circle'
                        : 'mdi-checkbox-blank-circle-outline'
                    "
                  ></v-icon>
                  <span
                    :class="
                      getReportsStatus == 'self'
                        ? 'success-text font-weight-bold'
                        : ''
                    "
                  >
                    My Tasks</span
                  >
                  <v-spacer></v-spacer>
                </div>
                <!--Show Others Tasks Filter -->
                <div
                  class="pa-2 caption d-flex anchor-hover pointer"
                  @click="
                    $store.commit('setReportsStatus', {
                      status: 'others',
                    })
                  "
                >
                  <v-icon
                    small
                    color="#1cc283"
                    class="mr-3"
                    v-text="
                      getReportsStatus == 'others'
                        ? 'mdi-checkbox-marked-circle'
                        : 'mdi-checkbox-blank-circle-outline'
                    "
                  ></v-icon>
                  <span
                    :class="
                      getReportsStatus == 'others'
                        ? 'success-text font-weight-bold'
                        : ''
                    "
                    >Others Tasks</span
                  >
                  <v-spacer></v-spacer>
                </div>
              </div>
            </div>
          </div>
          <!-- BY DEPARTMENT,  -->
          <v-row class="my-3" :no-gutters="!$vuetify.breakpoint.xs">
            <v-col cols="12">
              <span
                class="dark-purple-text text-capitalize font-weight-bold body-2"
              >
                By Description
              </span>
            </v-col>
            <!-- Department Filter -->
            <v-col v-if="getReportsView != 'project'" md="6" class="pr-3 mt-2">
              <div class="dusty-purple-text mb-1 body-2">Department</div>
              <div
                id="department-dropdown"
                class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer mr-5"
              >
                <v-chip
                  v-if="getSearchedDepartment"
                  class="pl-2 pr-3 blue-chip-color"
                  x-small
                >
                  <span class="d-inline-block text-truncate">
                    {{ getSearchedDepartment }}
                  </span>
                </v-chip>
                <span v-else>
                  Select Department
                </span>
                <v-spacer></v-spacer>
                <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
              </div>
            </v-col>
            <!-- FILTER BY MEMBERS -->
            <v-col
              v-show="
                (getSelectedCompany.role == 'admin' ||
                  getSelectedCompany.role == 'owner') &&
                  getReportsView == 'leader'
              "
              md="6"
            >
              <div
                :class="!$vuetify.breakpoint.xs ? 'ml-n2' : ''"
                class="dusty-purple-text mt-1 body-2 text-capitalize"
              >
                by Members
              </div>
              <div class="mt-5 caption d-flex align-end">
                <div
                  class="caption anchor-hover d-flex pb-2 pointer mr-3"
                  @click="
                    $store.commit('setLeadMembers', { leadMembers: 'all' })
                  "
                >
                  <v-icon
                    small
                    color="#1cc283"
                    class="mr-2"
                    :class="!$vuetify.breakpoint.xs ? 'ml-n3' : ''"
                  >
                    {{
                      getLeadMembers == "all"
                        ? "mdi-checkbox-marked-circle"
                        : "mdi-checkbox-blank-circle-outline"
                    }}
                  </v-icon>
                  <span
                    :class="
                      getLeadMembers == 'all'
                        ? 'success-text font-weight-bold'
                        : ''
                    "
                    >All Members</span
                  >
                  <v-spacer></v-spacer>
                </div>
                <div
                  class="anchor-hover d-flex pb-2 pointer mr-3"
                  @click="
                    $store.commit('setLeadMembers', {
                      leadMembers: 'members',
                    })
                  "
                >
                  <v-icon small color="#1cc283" class="mr-2">
                    {{
                      getLeadMembers == "members"
                        ? "mdi-checkbox-marked-circle"
                        : "mdi-checkbox-blank-circle-outline"
                    }}
                  </v-icon>
                  <span
                    :class="
                      getLeadMembers == 'members'
                        ? 'success-text font-weight-bold'
                        : ''
                    "
                  >
                    Team Members
                  </span>

                  <v-spacer></v-spacer>
                </div>
                <div
                  class="anchor-hover d-flex pb-2 pointer mr-3"
                  @click="
                    $store.commit('setLeadMembers', {
                      leadMembers: 'non_members',
                    })
                  "
                >
                  <v-icon small color="#1cc283" class="mr-3">
                    {{
                      getLeadMembers == "non_members"
                        ? "mdi-checkbox-marked-circle"
                        : "mdi-checkbox-blank-circle-outline"
                    }}
                  </v-icon>
                  <span
                    :class="
                      getLeadMembers == 'non_members'
                        ? 'success-text font-weight-bold'
                        : ''
                    "
                    >Non-members</span
                  >

                  <v-spacer></v-spacer>
                </div>
              </div>
            </v-col>
            <!-- Project Filter -->
            <v-col v-if="getReportsView == 'project'" md="6" class="pr-3 mt-2">
              <div class="dusty-purple-text mb-1 body-2">Project</div>
              <div
                id="project-dropdown"
                class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer"
              >
                <v-chip
                  v-if="getProjectSearchedQuery"
                  class="pl-2 pr-3 blue-chip-color"
                  x-small
                >
                  <span class="d-inline-block text-truncate">
                    {{ getProjectSearchedQuery.name }}
                  </span>
                </v-chip>
                <v-spacer></v-spacer>
                <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
              </div>
            </v-col>
            <!-- Member Filter  -->
            <v-col v-if="getReportsView == 'project'" md="6" class="pr-3 mt-2">
              <div class="dusty-purple-text mb-1 body-2">Member</div>
              <div
                id="member-dropdown"
                class="theme-border d-flex align-center border-radius-2 px-2 py-2 pointer"
              >
                <v-chip
                  v-if="getReportsSearchQuery"
                  class="pl-2 pr-3 blue-chip-color"
                  x-small
                >
                  <span class="d-inline-block text-truncate">
                    {{
                      getReportsSearchQuery.name
                        ? getReportsSearchQuery.name
                        : getReportsSearchQuery.email
                    }}
                  </span>
                </v-chip>
                <v-spacer></v-spacer>
                <v-icon small color="#2a206a">mdi-chevron-down</v-icon>
              </div>
            </v-col>
          </v-row>

          <!-- FILTER BY TIME -->
          <v-row>
            <!-- Filter by time -->
            <v-col cols="12" md="12">
              <div
                class="text-capitalize d-flex align-center dark-purple-text font-weight-bold body-2"
              >
                by Time
              </div>
              <div :class="isMac ? 'edited_scrollbar' : ''" class="d-flex">
                <v-list>
                  <div
                    v-for="list of dropdownList"
                    :key="list.text"
                    class="status-list-min-height caption anchor-hover d-flex align-center pointer"
                    @click="$store.commit('setReportsDate', list.text)"
                  >
                    <div class="d-flex align-center">
                      <v-icon small color="#1cc283" class="pr-2">
                        {{
                          getReportsDate == list.text
                            ? "mdi-checkbox-marked-circle"
                            : "mdi-checkbox-blank-circle-outline"
                        }}</v-icon
                      >
                      <span
                        :class="
                          getReportsDate == list.text
                            ? 'success-text font-weight-bold'
                            : ''
                        "
                        >{{ list.text }}</span
                      >
                    </div>
                  </div>
                </v-list>
                <div v-if="getReportsDate == 'Custom range'" style="width:80%" class="d-flex justify-center date-picker rounded mt-2 pb-2">
                  <div class="theme-border">
                  <v-date-picker
                      v-model="dateRange"
                      range
                    >
                    <v-card-actions class="pa-0 ma-0 w-100 d-flex justify-end">
                      <v-btn  
                      depressed
                      small
                      color="#edebf9"
                      class="text-capitalize theme-filled-btn"
                      @click="customRange()">OK
                      </v-btn>
                    </v-card-actions>
                  </v-date-picker>
                    
                  </div>
                 
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="border-top py-3">
          <div class="d-flex align-center w-100">
            <v-btn
              depressed
              small
              color="#edebf9"
              class="text-capitalize"
              @click="resetFilters"
            >
              <v-icon color="#2a206a" small>mdi-restore</v-icon>
              <span class="body-2 mx-1 dark-purple-text">Reset Filters</span>
            </v-btn>
          </div>
        </v-card-actions>
        <!-- DROPDOWNS -->
        <!-- Department Dropdown -->
        <v-menu
          v-if="getReportsView != 'project'"
          :close-on-content-click="false"
          activator="#department-dropdown"
          offset-y
          content-class="white"
        >
          <div :class="isMac ? 'edited_scrollbar' : ''">
            <!-- search field -->
            <div class="search-border rounded ma-2">
              <v-text-field
                autofocus
                autocomplete="off"
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search..."
                class="body-2"
                color="#757096"
                hide-details
                dense
                solo
                flat
                v-model="searchDepartment"
              />
            </div>
            <v-list max-height="130" class="overflow-scroll" scrollable>
              <div
                v-if="!searchDepartment"
                class="d-flex list-item-min-height caption listing-hover pointer"
                :class="!getSearchedDepartment ? 'bg-selected' : ''"
                @click="
                  $store.commit('setSearchedDepartment', {
                    department: null,
                  })
                "
              >
                <profileImage
                  v-show="':username'"
                  inline
                  username="All"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content class="ml-2">
                  All Departments
                </v-list-item-content>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="!getSearchedDepartment ? 'mdi-check-box-outline' : ''"
                ></v-icon>
              </div>
              <div
                class="d-flex pointer list-item-min-height caption listing-hover"
                :class="
                  getSearchedDepartment &&
                  getSearchedDepartment == department.name
                    ? 'bg-selected'
                    : ''
                "
                v-for="department in filteredDepartments"
                :key="department.id"
                @click="
                  getSearchedDepartment &&
                  getSearchedDepartment == department.name
                    ? $store.commit('setSearchedDepartment', {
                        department: null,
                      })
                    : $store.commit('setSearchedDepartment', {
                        department: department.name,
                      })
                "
              >
                <profileImage
                  v-show="':username'"
                  inline
                  :username="department.name"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>

                <v-list-item-content
                  style="max-width: 160px"
                  class="d-inline-block text-truncate ml-2"
                >
                  {{ department.name }}</v-list-item-content
                >
                <v-spacer></v-spacer>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getSearchedDepartment &&
                    getSearchedDepartment == department.name
                      ? 'mdi-check-box-outline'
                      : ''
                  "
                ></v-icon>
              </div>

              <div v-if="searchDepartment && !filteredDepartments.length">
                <p class="no-results-found my-1">No results found</p>
              </div>
            </v-list>
          </div>
        </v-menu>
        <!-- Project Dropdown -->
        <v-menu
          v-if="getReportsView == 'project'"
          :close-on-content-click="false"
          activator="#project-dropdown"
          offset-y
          content-class="white"
        >
          <div :class="isMac ? 'edited_scrollbar' : ''">
            <!-- search field -->
            <div class="search-border py-0 rounded ma-2">
              <v-text-field
                autofocus
                autocomplete="off"
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search..."
                class="body-2"
                color="#757096"
                hide-details
                solo
                flat
                dense
                v-model="projectSearch"
              >
              </v-text-field>
            </div>
            <v-list max-height="130" class="pointer overflow-scroll" scrollable>
              <div
                v-if="!projectSearch"
                class="d-flex list-item-min-height caption listing-hover pointer"
                :class="!getProjectSearchedQuery ? 'bg-selected' : ''"
                @click="$store.commit('setSearchedProject', null)"
              >
                <profileImage
                  v-show="':username'"
                  inline
                  username="All"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content class="ml-2">
                  All Projects
                </v-list-item-content>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    !getProjectSearchedQuery ? 'mdi-check-box-outline' : ''
                  "
                ></v-icon>
              </div>
              <div
                v-for="project in projectsList"
                :key="project.id"
                class="list-item-min-height caption listing-hover d-flex pointer"
                :class="
                  getProjectSearchedQuery &&
                  getProjectSearchedQuery.id == project.id
                    ? 'bg-selected'
                    : ''
                "
                @click="
                  getProjectSearchedQuery &&
                  getProjectSearchedQuery.id == project.id
                    ? $store.commit('setSearchedProject', null)
                    : $store.commit('setSearchedProject', project)
                "
              >
                <profileImage
                  inline
                  :username="project.name"
                  :size="23"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content
                  ><span
                    style="width: 30px"
                    class="d-inline-block text-truncate ml-2 text-capitalize"
                  >
                    {{ project.name }}
                  </span>
                </v-list-item-content>
                <v-spacer></v-spacer>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getProjectSearchedQuery &&
                    getProjectSearchedQuery.id == project.id
                      ? 'mdi-check-box-outline'
                      : ''
                  "
                ></v-icon>
              </div>
              <div v-if="projectSearch && !projectsList.length">
                <p class="no-results-found my-1">No results found</p>
              </div>
            </v-list>
          </div>
        </v-menu>
        <!-- Member Dropdown -->
        <v-menu
          v-if="getReportsView == 'project'"
          :close-on-content-click="false"
          activator="#member-dropdown"
          offset-y
          content-class="white"
        >
          <div :class="isMac ? 'edited_scrollbar' : ''">
            <!-- search field -->
            <div class="search-border rounded ma-2">
              <v-text-field
                autofocus
                autocomplete="off"
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search..."
                class="body-2"
                color="#757096"
                hide-details
                dense
                solo
                flat
                v-model="searchMember"
              />
            </div>
            <v-list max-height="130" class="overflow-scroll" scrollable>
              <div
                v-if="!searchMember"
                class="d-flex list-item-min-height caption listing-hover pointer"
                :class="!getReportsSearchQuery ? 'bg-selected' : ''"
                @click="$store.commit('setMemberSearched', null)"
              >
                <profileImage
                  v-show="':username'"
                  inline
                  username="All"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content class="ml-2">
                  All Members
                </v-list-item-content>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="!getReportsSearchQuery ? 'mdi-check-box-outline' : ''"
                ></v-icon>
              </div>
              <div
                class="d-flex pointer list-item-min-height caption listing-hover"
                :class="
                  getReportsSearchQuery
                    ? member.id == getReportsSearchQuery.id
                      ? 'bg-selected'
                      : ''
                    : ''
                "
                v-for="member in filteredMembers"
                :key="member.id"
                @click="
                  getReportsSearchQuery && getReportsSearchQuery.id == member.id
                    ? $store.commit('setMemberSearched', null)
                    : $store.commit('setMemberSearched', member)
                "
              >
                <profileImage
                  v-show="member.image ? ':src' : ':username'"
                  :src="member.image"
                  inline
                  :username="member.name ? member.name : member.email"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>

                <v-list-item-content
                  style="max-width: 160px"
                  class="d-inline-block text-truncate ml-2"
                  :class="member.name ? 'text-capitalize' : ''"
                >
                  {{
                    member.name ? member.name : member.email
                  }}</v-list-item-content
                >
                <v-spacer></v-spacer>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    getReportsSearchQuery &&
                    getReportsSearchQuery.id == member.id
                      ? 'mdi-check-box-outline'
                      : ''
                  "
                ></v-icon>
              </div>

              <div v-if="searchMember && !filteredMembers.length">
                <p class="no-results-found my-1">No results found</p>
              </div>
            </v-list>
          </div>
        </v-menu>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  props: ["drawer"],
  components: {
    profileImage: () => import("@/components/Includes/ProfileImage"),
  },
  data() {
    return {
      dateRange: this.getCustomDateRange,
      projectSearch: null,
      searchMember: null,
      searchDepartment: null,
      flag: false,
      memberSearched: null,
      dropdownList: [
        { text: "Today" },
        { text: "Yesterday" },
        { text: "Last 7 days" },
        { text: "Last 30 days" },
        { text: "This month" },
        { text: "Last month" },
        {text: 'Custom range'},
        { text: "All time" },
      ],
      reportsList: [
        { text: "Team Leads", value: "leader" },
        { text: "Members", value: "user" },
        { text: "Projects", value: "project" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getReportsDate",
      "getReportsStatus",
      "getReportsView",
      "getSelectedCompany",
      "getLeadMembers",
      "getReportsSearchQuery",
      "getLoggedInUser",
      "getProjectAssociatedMembers",
      "getProjects",
      "getProjectSearchedQuery",
      "getDepartments",
      "getSearchedDepartment",
      'getCustomDateRange'
    ]),
    filteredMembers() {
      return this.getLoggedInUser && this.getProjectAssociatedMembers
        ? this.searchMember
          ? [this.getLoggedInUser]
              .concat(this.getProjectAssociatedMembers)
              .filter((item) => {
                return item.id != this.getLoggedInUser.id;
              })
              .filter((user) => {
                return user.name
                  ? user.name
                      .toLowerCase()
                      .includes(this.searchMember.toLowerCase())
                  : user.email
                      .toLowerCase()
                      .includes(this.searchMember.toLowerCase());
              })
          : [this.getLoggedInUser]
              .concat(this.getProjectAssociatedMembers)
              .filter((item) => {
                return item.id != this.getLoggedInUser.id;
              })
        : [];
    },
    projectsList() {
      return this.projectSearch && this.getProjects
        ? this.getProjects.filter((item) => {
            return item.name
              ? item.name
                  .toLowerCase()
                  .includes(this.projectSearch.toLowerCase())
              : false;
          })
        : this.getProjects;
    },
    filteredDepartments() {
      return this.searchDepartment && this.getDepartments
        ? this.getDepartments.filter((item) => {
            return item.name
              ? item.name
                  .toLowerCase()
                  .includes(this.searchDepartment.toLowerCase())
              : false;
          })
        : this.getDepartments;
    },
  },
  mounted() {
     eventBus.$on('customDateRange', (payload) => {
      this.dateRange = payload
    })
  },
  beforeDestroy() {
     eventBus.$off("customDateRange");
  },
  watch: {
    drawer(value) {
      if (value) this.flag = true;
    },
    flag(value) {
      if (!value) this.$emit("update:drawer", false);
    },
  },
  methods: {
    customRange() {
       this.$store.commit('setCustomDateRange', this.dateRange)
    },
    resetFilters() {
      if (
        this.getSelectedCompany.role == "admin" ||
        this.getSelectedCompany.role == "owner"
      ) {
        this.$store.commit("setReportsView", "leader");
        if (this.getReportsView == "leader") {
          this.$store.commit("setLeadMembers", { leadMembers: "all" });
        }
      }
      this.$store.commit("setReportsStatus", { status: "all" });
      this.$store.commit("setSearchedDepartment", {
        department: null,
      });
      this.$store.commit("setSearchedProject", null);
      this.$store.commit("setMemberSearched", null);
      this.$store.commit("setReportsDate", "Yesterday");
    },
  },
};
</script>
<style scoped>
.w-45 {
  width: 45%;
}
</style>
<style>
.datetime-picker input[data-v-a46a390c] {
  width: 150px !important;
  height: 38px !important;
}
.date-picker .v-picker__title {
  display: none !important;
}
.date-picker .v-date-picker-table--date .v-btn {
height: 24px !important;
width: 24px !important;
}
.date-picker .v-date-picker-table {
  height: 190px !important;
}
</style>
